// Ads Campaigns › AdWatch — ฝังระบบติดตามโฆษณาคู่แข่ง (Competitive Ads Intelligence)
//
// ไม่ส่งพารามิเตอร์แบรนด์ไป: เขาแบ่งด้วย product group ของตัวเอง (?pg=) ซึ่งเป็นชุด
// คนละชุดกับกลุ่มของเรา — ที่เห็นเป็น "Detergent" รวม Downy/Fineline/PAO และค่าที่
// ส่งไปมั่ว ๆ ก็ได้ 200 กลับมา จึงตรวจจากฝั่งเราไม่ได้ว่าส่งถูกหรือเปล่า ปล่อยให้หน้า
// เขาเลือกกลุ่มเองปลอดภัยกว่าเดาแล้วพาไปหน้าที่ว่าง
//
// ระบบนอกอาจตั้ง X-Frame-Options ไว้จนฝังไม่ได้ ซึ่งเราตรวจจากในหน้าไม่ได้เลย
// จึงมีปุ่ม "เปิดในแท็บใหม่" คู่ไว้เสมอเป็นทางออก (เหมือนหน้ารายงานอื่นที่ฝังข้ามโดเมน)
import type { Brand } from "@contracts/api";
import { EmbedHead } from "@features/embeds/components/embed-head";

const ADWATCH_BASE = "https://adwatch.datafirst.id";

export function AdWatchPage({ brand }: { brand: Brand }) {
  return (
    <>
      <EmbedHead
        crumb={`${brand.name} / Ads Campaigns`}
        title="AdWatch"
        right={
          <a
            className="btn-outline inline-btn"
            href={ADWATCH_BASE}
            target="_blank"
            rel="noreferrer"
          >
            เปิดในแท็บใหม่ ↗
          </a>
        }
      />
      <div className="embed-frame">
        <iframe src={ADWATCH_BASE} title="AdWatch" allow="clipboard-write" />
      </div>
    </>
  );
}
